<template>
	<alert position="bottom">
		<p>
			当前路径：<code>{{$route.path}}</code>;
			当前参数：<code>{{$route.params}}</code>;
			路由名称：<code>{{$route.name}}</code>;
			路由查询参数：<code>{{$route.query}}</code>
		</p>
	</alert>
</template>
<script>
	import alert from 'components/comp/alert'
	export default {
		components: {
			alert
		},
	}
</script>


// WEBPACK FOOTER //
// routebox.vue?c58d9c0e